import React from 'react';
import styled from 'styled-components';
import { useLanguage } from '../contexts/LanguageContext';
import { content } from '../data/content';

const ContactContainer = styled.section`
  background: #000000;
  background-image: 
    radial-gradient(circle at 25% 25%, rgba(138, 138, 126, 0.08) 1px, transparent 1px),
    radial-gradient(circle at 75% 75%, rgba(138, 138, 126, 0.06) 1px, transparent 1px);
  background-size: 80px 80px, 120px 120px;
  padding: 80px 0;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(90deg, transparent, rgba(138, 138, 126, 0.4), transparent);
    z-index: 1;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(90deg, transparent, rgba(138, 138, 126, 0.3), transparent);
    z-index: 1;
  }
`;

const ContactContent = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 0 20px;
  text-align: center;
  position: relative;
  z-index: 2;
`;

const ContactTitle = styled.h2`
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: #b7ab9f;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const ContactSubtitle = styled.h3`
  font-size: 1.4rem;
  color: #ffffff;
  margin-bottom: 3rem;
  font-weight: 500;
`;

const ContactText = styled.p`
  font-size: 1.1rem;
  color: #cccccc;
  line-height: 1.7;
  margin-bottom: 3rem;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
`;

const ContactCTA = styled.a`
  background: #b7ab9f;
  color: #ffffff;
  border: 2px solid #b7ab9f;
  padding: 1.2rem 3rem;
  font-size: 1.1rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 4rem;
  text-decoration: none;
  display: inline-block;

  &:hover {
    background: transparent;
    color: #b7ab9f;
  }
`;

const ContactDivider = styled.div`
  width: 100px;
  height: 1px;
  background: #b7ab9f;
  margin: 0 auto 3rem;
`;

const ContactDetails = styled.div`
  display: flex;
  justify-content: center;
  gap: 4rem;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 2rem;
    align-items: center;
  }
`;

const ContactDetail = styled.div`
  text-align: center;
  min-width: 180px;
`;

const ContactLabel = styled.h4`
  font-size: 1rem;
  font-weight: 700;
  color: #b7ab9f;
  margin-bottom: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

const ContactValue = styled.p`
  font-size: 1.1rem;
  color: #ffffff;
  font-weight: 500;
  line-height: 1.4;
`;

const Contact = () => {
  const { language } = useLanguage();
  const t = content[language];

  const mailtoLink = `mailto:Info@groupegarant.com`;

  return (
    <ContactContainer id="contact">
      <ContactContent>
        <ContactTitle className="content-entry-animation">
          {t.contact.title}
        </ContactTitle>
        <ContactSubtitle className="content-entry-animation">
          {t.contact.subtitle}
        </ContactSubtitle>

        <ContactText className="content-entry-animation">
          {language === 'fr' 
            ? 'Réinventez votre approche de vente de garanties mécaniques prolongées. Contactez Groupe Garant pour découvrir comment nous pouvons propulser votre rentabilité et dynamiser votre relance après-vente.' 
            : 'Reinvent your approach to selling extended mechanical warranties. Contact Groupe Garant to discover how we can boost your profitability and energize your after-sales follow-up.'
          }
        </ContactText>
        
        <ContactCTA className="content-entry-animation" href={mailtoLink}>
          {t.contact.cta}
        </ContactCTA>

        <ContactDivider />

        <ContactDetails>
          <ContactDetail className="content-entry-animation">
            <ContactLabel>Email</ContactLabel>
            <ContactValue>{t.contact.email}</ContactValue>
          </ContactDetail>
          
          <ContactDetail className="content-entry-animation">
            <ContactLabel>{language === 'fr' ? 'Téléphone' : 'Phone'}</ContactLabel>
            <ContactValue>{t.contact.phone}</ContactValue>
          </ContactDetail>
        </ContactDetails>
      </ContactContent>
    </ContactContainer>
  );
};

export default Contact; 
